/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.2.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NextPortArrival } from './NextPortArrival';
import {
    NextPortArrivalFromJSON,
    NextPortArrivalFromJSONTyped,
    NextPortArrivalToJSON,
} from './NextPortArrival';

/**
 * 
 * @export
 * @interface NextportArrivalsClusterGet200Response
 */
export interface NextportArrivalsClusterGet200Response {
    /**
     * 
     * @type {Array<NextPortArrival>}
     * @memberof NextportArrivalsClusterGet200Response
     */
    records: Array<NextPortArrival>;
}

/**
 * Check if a given object implements the NextportArrivalsClusterGet200Response interface.
 */
export function instanceOfNextportArrivalsClusterGet200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "records" in value;

    return isInstance;
}

export function NextportArrivalsClusterGet200ResponseFromJSON(json: any): NextportArrivalsClusterGet200Response {
    return NextportArrivalsClusterGet200ResponseFromJSONTyped(json, false);
}

export function NextportArrivalsClusterGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextportArrivalsClusterGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': ((json['records'] as Array<any>).map(NextPortArrivalFromJSON)),
    };
}

export function NextportArrivalsClusterGet200ResponseToJSON(value?: NextportArrivalsClusterGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': ((value.records as Array<any>).map(NextPortArrivalToJSON)),
    };
}

